import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { rootAction } from '../../redux';
import { logAnalyticsEvent } from '../../redux/actions/analyticsLog';
import { deleteCartItem } from '../../redux/actions/deleteCartItemActions';
import { updateUseDiscountsAction } from '../../redux/actions/updateUseDiscountsActions';
import { cartContentItemAttrSelector } from '../../redux/selectors/cartContentSelector';
import CheckoutItemCard from './CheckoutItemCard';

const mapStateToProps = (_initialState, initialOwnProps) => {
  const vid = initialOwnProps.vid;
  const selector = createStructuredSelector({
    userSubmitId: cartContentItemAttrSelector(vid, 'user_submit_id'),
    colorText: cartContentItemAttrSelector(vid, 'color_text'),
    imageUrl: cartContentItemAttrSelector(vid, 'image_url'),
    skuImageUrl: cartContentItemAttrSelector(vid, 'sku_image_url'),
    isCheck: cartContentItemAttrSelector(vid, 'isChecked'),
    price: cartContentItemAttrSelector(vid, 'price'),
    sizeText: cartContentItemAttrSelector(vid, 'size_text'),
    title: cartContentItemAttrSelector(vid, 'title'),
    hasCVSCOD: cartContentItemAttrSelector(
      vid,
      'delivery_modes',
      'has_cvs_cod'
    ),
    hasCVS: cartContentItemAttrSelector(vid, 'delivery_modes', 'has_cvs'),
    hasHomeCOD: cartContentItemAttrSelector(
      vid,
      'delivery_modes',
      'has_home_cod'
    ),
    ribbonText: cartContentItemAttrSelector(vid, 'ribbon_text'),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      logEvent: logAnalyticsEvent,
      updateSelectedCart: rootAction.actionsList.updateSelectedCart,
      deleteCartItem: deleteCartItem.request,
      updateUseDiscount: updateUseDiscountsAction,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutItemCard);
